import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import ServiceTable from "../../components/admin/service/service";

const ServicesAdminPage = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <ServiceTable />
    </div>
  );
};

export default ServicesAdminPage;
